export const TestIds = {
  container: 'Avatar',
};
